import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { formatNumber } from "../../utils/functions";
import { getDistributionGraph } from "../../../Redux/actions/credit-line";
import { getDistributions } from "../../../Redux/reducer/credit-line";

const DashboardLine = ({ holdMount }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const line = useSelector((state) => getDistributions(state));

  useEffect(() => {
    async function fecthData() {
      return await dispatch(getDistributionGraph());
    }

    fecthData();
  }, []);

  const getItemValue = (value) => {
    var mount = 0;
    var symbol = "";

    if (undefined !== line.list && line.list.length > 0) {
      line.list.map((item) => {
        if (item.status == value) {
          mount = item.amount;
          symbol = item.currency.currencySymbol;
        }
      });
    }

    return mount > 0 ? formatNumber(mount, symbol) : "-";
  };

  /*   const getData = () => {
    return line.list.find((item) => item.status === "MONTO_TRANSITO");
  }; */

  const cleanValue = (value) =>
    Math.round((value + Number.EPSILON) * 100) / 100;

  const cleanAndFormatNumber = (value, symbol) => {
    return formatNumber(cleanValue(value), symbol);
  };

  const showAmount = (property) => {
    const crcAmount = holdMount?.CRC?.[property];
    const usdAmount = holdMount?.USD?.[property];

    const isHold = property === "hold";

    const className = isHold ? "selectedMount" : "selectedMount usedLine";
    const label = t(
      `dashboard.creditLine.${isHold ? "selectedAmount" : "payAmmount"}`
    );

    if (crcAmount || usdAmount) {
      let amount;
      if (crcAmount && usdAmount) {
        amount = `${cleanAndFormatNumber(crcAmount)} - ${cleanAndFormatNumber(
          usdAmount,
          "$"
        )}`;
      } else if (crcAmount) amount = `${cleanAndFormatNumber(crcAmount)}`;
      else amount = `${cleanAndFormatNumber(usdAmount, "$")}`;

      return (
        <div className={className}>
          <p>{label}</p>
          <h3>{amount}</h3>
        </div>
      );
    }
    return null;
  };
  console.log({ holdMount });

  return (
    <div className={`mainCredit`}>
      <div className="creditLine">
        {showAmount("hold")}
        {showAmount("payAmount")}
        {/*       {holdMount !== undefined &&
          holdMount.hold > 0 &&
          getData() !== undefined && (
            <div className="selectedMount">
              <p>{t("dashboard.creditLine.selectedAmount")}</p>
              <h3>{`${formatNumber(
                cleanValue(holdMount.hold),
                getData().currency.currencySymbol
              )}`}</h3>
            </div>
          )} */}
        {/*    {holdMount !== undefined &&
          holdMount.payAmount > 0 &&
          getData() !== undefined && (
            <div className="selectedMount usedLine">
              <p>{t("dashboard.creditLine.payAmmount")}</p>
              <h3>{`${formatNumber(
                cleanValue(holdMount.payAmount),
                getData().currency.currencySymbol
              )}`}</h3>
            </div>
          )} */}
        <div className="flex-element left-flex">
          <div className="availableLine">
            <p>{t("dashboard.creditLine.header_amount_acepted")}</p>
            <h3>{getItemValue("MONTO_ACEPTADO")}</h3>
          </div>
          <div className="usedLine">
            <p>{t("dashboard.creditLine.header_total_amount")}</p>
            <h3>{getItemValue("TOTAL_RECIBIR")}</h3>
          </div>
        </div>
      </div>
      <div className="mounts">
        <div className="aprovedAmount">
          <p>{t("dashboard.creditLine.header_amount_transit")}</p>
          <h3>{getItemValue("MONTO_TRANSITO")}</h3>
        </div>
      </div>
    </div>
  );
};

export default DashboardLine;
